/* Infinite horizontal loop for homepage carousels (.blh-vids reviews, .blh-docs doctors on mobile).
   Appends two copies of the cards, starts on the middle copy and silently jumps by one set width
   when the user scrolls past the middle, so the row never ends. Only runs when the row overflows. */
(function () {
  function setup(track) {
    if (track.__blLoop) return;
    if (track.scrollWidth <= track.clientWidth + 4) return;
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return;
    track.__blLoop = true;
    for (var c = 0; c < 2; c++) {
      items.forEach(function (el) {
        var k = el.cloneNode(true);
        k.setAttribute('aria-hidden', 'true'); k.removeAttribute('data-shopify-editor-block');
        k.querySelectorAll('a,button').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
        track.appendChild(k);
      });
    }
    var first = items[0], n = items.length;
    function setW() { return track.children[n].offsetLeft - first.offsetLeft; }
    var W = setW();
    function jump(to) {
      var snap = track.style.scrollSnapType; track.style.scrollSnapType = 'none';
      track.scrollLeft = to;
      requestAnimationFrame(function () { track.style.scrollSnapType = snap; });
    }
    jump(W);
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false; W = setW() || W;
        if (track.scrollLeft < W * 0.5) jump(track.scrollLeft + W);
        else if (track.scrollLeft > W * 1.5) jump(track.scrollLeft - W);
      });
    }, { passive: true });
    window.addEventListener('resize', function () { W = setW() || W; });
  }
  function init() { document.querySelectorAll('.blh-vids, .blh-docs').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
